import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor() {}

  public isArrValid(arr: any[]): boolean {
    if (arr === undefined || arr === null || !(arr.length > 0)) {
      return true;
    } else {
      return false;
    }
  }
}
